'use client';

import { useEffect } from 'react';

/**
 * Adds the `panel-bg` class to #main-scroll when mounted.
 * Use in pages that should have a tinted background (settings, wallet, analytics, etc.).
 */
export function PanelBackground() {
  useEffect(() => {
    const el = document.getElementById('main-scroll');
    if (el) el.classList.add('panel-bg');
    return () => {
      if (el) el.classList.remove('panel-bg');
    };
  }, []);
  return null;
}
